export default __webpack_public_path__ + "static/media/localtext.d7cc3234.csv";